export enum PhoneNumberType {
    Primary,
    Secondary,
    Tertiary,
    Home,
    Work,
    Hotline,
    Cell,
    AlternativeCell,
    Fax,
    AlternativeFax,
    Switchboard,
    Data,
    Sms,
}
